import Modal from "./Modal"
import PrepayForm from "../../components/PrepayForm"

// UT Bills entry point for prepaying a company. The form, its money rules, and
// its result screen are shared with Global Wallet Settings, so both places
// behave identically.
function PrepayModal({ onDone, onClose }) {
  return (
    <Modal
      title="Prepay a company"
      subtitle="Money leaves your Bills &amp; Invoices wallet now and waits for that company's bills"
      icon="arrow-up-right-circle"
      onClose={onClose}
    >
      <PrepayForm
        onCancel={onClose}
        onDone={(result) => {
          if (typeof onDone === "function") onDone(result)
        }}
      />
    </Modal>
  )
}

export default PrepayModal
